import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AddAccountComponent } from "./add-account/add-account.component";



@NgModule({
  declarations: [AddAccountComponent],
  exports:[
    AddAccountComponent
      ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BrowserModule,
    FormsModule
  ]
})
export class AddAccountModule { }
